import React from "react";
import AboutPage from "../Components/About/AboutPage";
import Seo from "../Components/Seo/Seo";
import { useSiteSeo } from "../context/SiteSeoContext";
import { truncateMetaDescription } from "../utils/seoText";
import { usePrerenderReady } from "../utils/prerenderReady";
import { usePageSeo } from "../hooks/usePageSeo";
import { useManagedPageContent } from "../hooks/useManagedPageContent";
import BlockRenderer from "../Components/BlockRenderer/BlockRenderer";

const About = () => {
  const { blocks, loaded } = useManagedPageContent('about');
  usePrerenderReady(loaded);
  const siteCtx = useSiteSeo();
  const { seo_title: pageSeoTitle, seo_description: pageSeoDesc, og_image_url: pageOgImage } = usePageSeo('about');
  const titleSuffix =
    siteCtx.organization_name && String(siteCtx.organization_name).trim()
      ? ` | ${String(siteCtx.organization_name).trim()}`
      : " | Gem Fashion Studios";
  return (
    <>
      <Seo
        title={pageSeoTitle || `About Gem Fashion Studios${titleSuffix}`}
        description={pageSeoDesc || truncateMetaDescription(
          "Our rental boutique in Mumbai: designer clothing for events, sizing help, try-on, delivery, and returns."
        )}
        canonicalPath="/about"
        ogImage={pageOgImage || undefined}
      />
      {blocks ? <BlockRenderer content={blocks} /> : <AboutPage />}
    </>
  );
};

export default About;
